import * as Yup from 'yup';

const maxError = (value = 128) => `Max ${value} characters only`;
const minError = (value: number) => `The min value must be ${value} or greater`;

export const TitleFeesValidationSchema = Yup.object().shape({
  state: Yup.string().required(),
  category: Yup.string().required().min(1, minError(1)).max(128, maxError()),
  description: Yup.string().required().min(1, minError(1)).max(128, maxError()),
});